export const listingDetail = {
  breadcrumb: {
    listings: "Anúncios",
    detailFallback: "Detalhes",
  },
  hero: {
    noName: "Sem nome",
    editNameTitle: "Editar nome",
    channelConnected: "Conectado ao canal (OTAs)",
    channelDisconnected: "Não conectado ao canal",
  },
  units: {
    unitsCount: "{count} unidades",
    roomsCount: "{count} quarto | {count} quartos",
    maxGuests: "Máx. {count} hóspedes",
    searchPlaceholder: "Buscar unidade…",
    dragTitle: "Arraste para reordenar",
    headerRoomTypes: "TIPOS DE QUARTO",
    headerLinkedUnits: "UNIDADES VINCULADAS",
    addBtnTitle: "Adicionar unidade",
    movedBadge: "movido",
    unitFallback: "Unidade",
  },
  typeLabels: {
    apartment: "Apartamento",
    house: "Casa",
    villa: "Vila",
    hotel: "Hotel",
    room: "Quarto",
    studio: "Estúdio",
    fallback: "Acomodação",
  },
  aiReception: {
    title: "Recepção com IA",
  },
  toggles: {
    enableAgent: {
      label: "Ativar agente de IA",
      hint: "Automatize o atendimento aos hóspedes pelo WhatsApp.",
    },
    otaAgent: {
      label: "Agente de IA para OTAs",
      hintOn: "Também responde a mensagens do Booking, Airbnb e outras OTAs.",
      hintOff: "Requer que o agente de IA esteja ativo.",
    },
  },
  status: {
    active: "Ativo",
    inactive: "Inativo",
  },
  emptyUnits: {
    title: "Sem unidades",
    subHotel: "Crie o primeiro quarto ou unidade deste hotel para começar a configurar tarifas e disponibilidade.",
    subDefault: "Adicione a primeira unidade a este anúncio para começar a receber hóspedes.",
    ctaPreparing: "Preparando…",
    ctaAddRoom: "Adicionar quarto",
    ctaAddFirstUnit: "Adicionar primeira unidade",
  },
  sortBar: {
    add: "Adicionar",
    addRoom: "Adicionar quarto",
    saving: "Salvando…",
    done: "Concluído",
    sort: "Reordenar",
    dragHint: "Arraste para reordenar",
  },
  propOptions: {
    scheduled: "Mensagens programadas",
    services: "Equipamentos e comodidades",
    locks: "Fechaduras",
    faq: "Perguntas e respostas",
    arrival: "Instruções de chegada",
    checkout: "Mensagem de check-out",
    welcome: "Mensagem de boas-vindas",
    description: "Descrição",
    capacity: "Capacidade",
  },
  addZone: {
    titleRoom: "Adicionar quarto",
    titleUnit: "Adicionar unidade",
    roomLower: "quarto",
    unitLower: "unidade",
    createNew: "Criar um novo {noun} dentro",
    eachHas: "Cada {noun} tem suas próprias configurações (descrição, capacidade, acesso…).",
    ctaPreparing: "Preparando…",
    ctaCreateRoom: "Criar quarto",
    ctaCreateUnit: "Criar unidade",
  },
  danger: {
    deleteListing: "Excluir anúncio...",
    notePrefix: "Exclui o anúncio",
    noteSuffix: " e todas as suas unidades do WACheckin. Esta ação não pode ser desfeita.",
  },
  toast: {
    orderSaved: "Ordem salva com sucesso",
  },
  errors: {
    loadListing: "Não foi possível carregar a acomodação.",
  },
  authorities: {
    title: "Autoridades",
    description: "Configure a conexão com as autoridades locais para o envio automático do registro de hóspedes.",
  },
  cards: {
    knowledge: { title: "Base de conhecimento", status: "Informações que o agente usa" },
    earlyAccess: { title: "Acesso antecipado", status: "Horários de chegada e check-in antecipado" },
    lateCheckout: { title: "Check-out tardio", status: "Check-out tardio e preço" },
    extendStay: { title: "Estender estadia", status: "Estender as noites da reserva" },
    invoicing: { title: "Faturamento", status: "Dados fiscais · compatível com Verifactu" },
    location: { title: "Localização", sub: "Endereço da acomodação" },
    logo: { title: "Marca", sub: "Identidade visual" },
    welcome: { title: "Mensagem de boas-vindas", sub: "Personalize as boas-vindas" },
    checkin: { title: "Check-in", sub: "Instruções de entrada e horário" },
    policies: { title: "Políticas da acomodação", sub: "Regras e condições" },
    authorities: { sub: "Registro nas autoridades" },
    hotelRates: { title: "Tarifas do hotel", sub: "Tarifas base e derivadas" },
    roomManagement: { title: "Quartos", sub: "Tipos de quarto e inventário" },
    rates: { title: "Tarifas", sub: "Tarifas base e derivadas" },
    ota: { title: "Conectar OTA", subPaid: "Booking · Airbnb · Vrbo · Expedia", subUnpaid: "Requer uma assinatura ativa" },
    ical: { title: "Calendário iCal", sub: "Sincronização de calendário" },
    ownerSettlement: { title: "Proprietário e repasse", sub: "Se você administra para outro proprietário: comissão e repasse", subManaged: "Administrado para {owner} · {pct}%", subManagedNoOwner: "Administrado · {pct}% · sem proprietário atribuído" },
    otaCommissions: { title: "Comissões das OTAs", sub: "Quanto cada OTA retém e quanto você recebe", subActive: "A ficha mostra quanto você recebe de cada reserva" },
    description: { title: "Descrição", sub: "Detalhes da unidade" },
    capacity: { title: "Capacidade", sub: "Hóspedes e camas" },
    services: { title: "Equipamentos e comodidades", sub: "O que oferece, com fotos" },
    unitFaq: { title: "Perguntas e respostas", sub: "Específicas desta unidade para o agente" },
    rules: { title: "Horários", sub: "Horários de check-in e check-out" },
    upselling: { title: "Experiências e serviços", sub: "Serviços de upselling" },
    checkinStore: { title: "Loja do check-in", sub: "Envie-a ao hóspede à chegada" },
    bookingConfirmation: { title: "Notificar nova reserva", sub: "Avisamos o hóspede pelo WhatsApp quando a reserva é confirmada" },
    arrivalInstructions: { title: "Instruções de chegada", sub: "Como chegar e entrar · com horário de envio" },
    checkoutMessage: { title: "Mensagem de check-out", sub: "Lembrete de check-out · modelo" },
    scheduledMessages: { title: "Mensagens programadas", sub: "Mensagens automáticas antes, durante e depois da estadia" },
    review: { title: "Solicitar avaliação", sub: "Reputação da acomodação" },
    identity: { title: "Verificação de identidade", sub: "Segurança do hóspede" },
    journeySim: { title: "Simular jornada do hóspede", sub: "Reproduz todo o processo no WhatsApp · envie para um telefone para testar" },
    smartlocks: { title: "Fechaduras e acesso", sub: "Como o hóspede entra" },
    integrations: { title: "Conexões e integrações", sub: "APIs e conexões adicionais" },
    welcomeInline: { sub: "Mensagem específica desta unidade" },
    newBookings: { title: "Novas reservas" },
  },
  badges: {
    ai: "IA",
    setup: "Configuração",
    hotel: "Hotel",
    subscription: "Assinatura",
    comingSoon: "Em breve",
    test: "Teste",
    manager: "Gestor",
    active: "Ativo",
  },
  sections: {
    essential: { title: "Configuração essencial", description: "Configurações básicas necessárias para publicar e gerenciar a acomodação." },
    management: { title: "Gestão da acomodação", description: "Configure tarifas, disponibilidade e canais de venda." },
    direct: { title: "Detalhar esta unidade", description: "Informações adicionais que usamos para reservas diretas e para alimentar o Agente de IA." },
    guest: { title: "Experiência do hóspede", description: "Configure a comunicação antes, durante e depois da estadia." },
    access: { title: "Acesso e integrações", description: "Gerencie acessos, fechaduras e conexões externas." },
  },
  otaModal: {
    title: "Conexão com OTA",
    html: "Conectar Booking, Airbnb, Vrbo, Expedia (channel manager) requer uma <b>assinatura ativa</b>.<br><small>Enquanto isso, você pode usar os demais recursos e sincronizar calendários via iCal (grátis).</small>",
    confirm: "Ativar assinatura",
    cancel: "Agora não",
  },
};
